export const BASE_PATH_PREFIX = "/";

export const LOGIN_PATH = "/login";
export const NOACCESS = "/no-access";
export const UNAUTHORIZED = "/unauthorized";
export const NOT_CONNECTED = "/not-connected";

export const TENANT_MANAGEMENT = "/tenant-management";
export const TENANT_DETAILS = `${TENANT_MANAGEMENT}/tenant-details/:id`;
export const TENANT_HIERARCHY_CONFIGURATION = "/tenant-hierarchy-configuration";
export const MASTER_TIMEZONE_MANAGEMENT = "/master-timezone-management";

export const LIVE_AVAILABLE_SHIFTS = "/live-available-shifts";

export const RAD_PATH = "/provider";
export const ADMIN_PATH = "/admin";
export const ADMIN_DROPDOWN_MANAGEMENT_PATH = "/admin/dropdown-management";
export const DROPDOWN_PATH = "/dropdown-management";
export const CONFIG_PATH = "/configuration";
export const EXAM_PATH = "/exam";
export const SITE_PATH = "/facility";
export const REPORT_PATH = "/reports";
export const STRATEGIC_FORECAST_PATH = "/strategic-forecast";
export const SCHEDULE_PATH = "/schedule";
export const VOLUME_TREND_REPORT = "/volume-trend-report";
export const DEMAND_TABLE = "/demand-table";
export const CAPSvsDEMANDTABLE = "/CapacityVsDemandReports";

export const FORECAST = "/demandForecast/forecasting";
export const FORECASTREPORT = "/demandForecast/report";
export const FORECAST_OPTIMIZE = "/demandForecast/optimize";
export const FORECAST_CAPSVSDEMAND = "/demandForecast/capsvsdemand";
// New Forecast 2.0 routes
// export const FORECAST2 = '/demandForecast/forecasting2';
export const FORECASTREPORT2 = "/demandForecast/report2";

export const OPTIMIZE = "/optimize";
export const SCHEDULE = "/scheduling";

export const FORECAST_PATH = "/forecasting";
export const FORECASTING_FORECAST = `${FORECAST_PATH}/forecast`;
export const GENERATE_FORECAST = `${FORECAST_PATH}/generateForecast`;
export const FORECASTING_OPTIMIZE = `${FORECAST_PATH}/optimize`;
export const DEMAND_FORECAST = `${FORECAST_PATH}/demandForecast`;
export const FORECASTING_SCHEDULES = `${FORECAST_PATH}/schedules`;
export const CAPACITY_FORECAST = `${FORECAST_PATH}/capacityForecast`;

export const RAD_LIST = `${RAD_PATH}/list`;
export const UNASSIGNED_PROVIDER_LIST = `${RAD_PATH}/unassigned-providers`;
export const STATE_LICENSE = `${RAD_PATH}/state-license`;
export const LICENSE_PRIVILEGE_POWER_SYNC = `${RAD_PATH}/license-privilege-power-sync`;
export const CAPACITY_INPUT = `${RAD_PATH}/capacity-input`;
export const CAPACITY_INPUT_NEW = `${RAD_PATH}/capacity`;
export const CUSTOM_VIEW = `${RAD_PATH}/custom-view`;
export const RAD_CUSTOM_VIEW = `${RAD_PATH}/ProviderCustomView`;
export const CONFIG_CUSTOM_VIEW = `${CUSTOM_VIEW}/config-custom-view`;
export const CONFIG_CUSTOM_VIEW_EDIT = `${CUSTOM_VIEW}/config-custom-view/:id`;
export const RAD_LEADERSHIP_BULK_UPDATE = `${RAD_PATH}/leadership-bulk-update`;
export const RAD_HOURLY_VOLUME_SHARE = `${RAD_PATH}/hourly-volume-share`;
export const ANNUAL_HOUR_TRACKER = `${RAD_PATH}/annual-hour-tracker`;
export const AUDIT_LOGS = `${RAD_PATH}/audit-logs`;
export const RAD_PROFILE = `${RAD_PATH}/providerProfile`;
export const EDIT_RAD_PROFILE = `${RAD_PATH}/edit-provider-profile`;

export const REGIONALPRACTICEWORKLIST = `${ADMIN_PATH}/regional-practice-worklist`;
export const NATIONAL = `${ADMIN_PATH}/national`;
export const REGION = `${ADMIN_PATH}/region`;
export const REGIONALPRACTICE = `${ADMIN_PATH}/regional-practice`;
export const RPCE = `${ADMIN_PATH}/rpce`;
export const WORKLIST = `${ADMIN_PATH}/worklist`;
export const WORKLIST_DEFINITION = `${ADMIN_PATH}/worklist-definition`;
export const WORKLIST_DEFINITION_CONFIGURATION = `${ADMIN_PATH}/worklist-definition/configuration`;
export const WORKLIST_GROUP = `${ADMIN_PATH}/worklist-group`;
export const TAG_CATEGORY_CONFIGURATION = `${ADMIN_PATH}/tag-category-configuration`;
export const SUBPRACTICE = `${ADMIN_PATH}/subpractice`;
export const PRACTICE = `${ADMIN_PATH}/practice`;
export const SECTIONWORKLIST = `${ADMIN_PATH}/sectionworklist`;
export const USERMANAGEMENT = `${ADMIN_PATH}/user-management`;
export const HOLIDAYPLANNER = `${ADMIN_PATH}/holiday-planner`;
export const HOLIDAYDEMANDPLANNER = `${ADMIN_PATH}/holiday-demand-planner`;
export const MAIN_PRACTICE = `${ADMIN_PATH}/main-practice`;

export const RAD_TYPE = `${ADMIN_PATH}/provider-type`;
export const RAD_STATUS = `${ADMIN_PATH}/provider-status`;

export const PROVIDER_DOCUMENT_TYPE = `${ADMIN_PATH}/provider-document-type`;
export const PROVIDER_NOTE_TYPE = `${ADMIN_PATH}/note-category`;

export const RAD_COMMUNICATION_TYPE = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/provider-communication-type`;
export const SCHEDULETYPE = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/scheduletype`;
export const SUBSPECIALITY = `${ADMIN_PATH}${DROPDOWN_PATH}/subspeciality`;
export const WEEK_ROTATION = `${ADMIN_PATH}${DROPDOWN_PATH}/week-rotation`;
export const WEEK_ROTATION_TEMPLATE = `${ADMIN_PATH}${DROPDOWN_PATH}/week-rotation-template`;
export const PARTNERSHIP_RATE = `${ADMIN_PATH}${DROPDOWN_PATH}/partnership-rate`;
export const PARTNERSHIP_STATUS = `${ADMIN_PATH}${DROPDOWN_PATH}/partnership-status`;
export const PARTNERSHIP_TIME = `${ADMIN_PATH}${DROPDOWN_PATH}/time-to-partnership`;
export const RAD_DEGREE = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/provider-designation`;
export const COMMITTEES = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/committees`;
export const FUTURE_SECTION_CHANGE = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/future-section-change`;
export const RVURATE = `${ADMIN_PATH}${DROPDOWN_PATH}/rvurate`;
export const TIMEZONE_MANAGEMENT = `${ADMIN_PATH}${DROPDOWN_PATH}/timezone-management`;
export const REQUEST_STATUS = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/providerrequest`;
export const TRAUMA_FACILITY_LEVEL = `${ADMIN_PATH}${DROPDOWN_PATH}/trauma-facility-level`;
export const QGENDA_SECTION = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/encore-section`;
export const SITE_STATUS = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/facility-status`;

export const MODALITY = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/modality`;
export const PRIORITY = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/priority`;
export const STAFF_CATEGORY = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/staff-category`;
export const STAFF_PRIMARY_LOCATION = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/staff-primary-location`;
export const SPECIALTY_CASES = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/specialty-cases`;
export const STAFFING_AGENCY = `${ADMIN_DROPDOWN_MANAGEMENT_PATH}/staffing-agency`;

export const SITECOVERAGEMATRIX = `${ADMIN_PATH}${CONFIG_PATH}/FacilityCoverageMatrix`;
export const COVERAGE_GAP = `${ADMIN_PATH}${CONFIG_PATH}/coverage-gap`;
export const PRIORITYSLAMAPPING = `${ADMIN_PATH}${CONFIG_PATH}/PrioritySLAMapping`;
export const SHIFT_HOUR_CONFIGURATION = `${ADMIN_PATH}${CONFIG_PATH}/ShiftHourConfiguration`;
export const DLS_CONFIGURATION = `${ADMIN_PATH}${CONFIG_PATH}/DLSConfiguration`;
export const BLOCK_PLANNING = `${ADMIN_PATH}${CONFIG_PATH}/block-planning`;
export const DAY_OF_WEEK_CONFIGURATION = `${ADMIN_PATH}${CONFIG_PATH}/day-of-week-configuration`;
export const TASK_CONFIGURATION = `${ADMIN_PATH}${CONFIG_PATH}/TaskConfiguration`;
export const TASK_CONFIGURATION_PANEL = `${TASK_CONFIGURATION}/panel`;
export const TASK_CONFIGURATION_PANEL_BASE = `${TASK_CONFIGURATION_PANEL}/:taskId`;
export const TASK_CONFIGURATION_PANEL_GENERAL = `${TASK_CONFIGURATION_PANEL}/:taskId/general`;
export const TASK_CONFIGURATION_PANEL_TASK_TAGS = `${TASK_CONFIGURATION_PANEL}/:taskId/task-tags`;
export const TASK_CONFIGURATION_PANEL_PROVIDER_POOL = `${TASK_CONFIGURATION_PANEL}/:taskId/provider-pool`;
export const TASK_CONFIGURATION_PANEL_COMPENSATION = `${TASK_CONFIGURATION_PANEL}/:taskId/compensation`;
export const PROVIDER_TASK_POOL = `${ADMIN_PATH}${CONFIG_PATH}/provider-pool`;
export const SIMULATOR_COLOR_CONFIGURATION = `${ADMIN_PATH}${CONFIG_PATH}/simulator-color-configuration`;
export const LICENSE_PRIVILEGE_STATUS_MAPPING = `${ADMIN_PATH}${CONFIG_PATH}/license-privilege-status-mapping`;
export const LICENSE_MAPPING = `${LICENSE_PRIVILEGE_STATUS_MAPPING}/license-mapping`;
export const PRIVILEGES_MAPPING = `${LICENSE_PRIVILEGE_STATUS_MAPPING}/privileges-mapping`;
export const READING_STATUS_MAPPING = `${LICENSE_PRIVILEGE_STATUS_MAPPING}/reading-status-mapping`;
export const DEFINE_MISMATCH = `${LICENSE_PRIVILEGE_STATUS_MAPPING}/define-mismatch`;

export const RAW_EXAM_DATA = `${EXAM_PATH}/raw-exam-data`;
export const EXAM_DATA = `${EXAM_PATH}/exam-data`;
export const UNREAD = `${EXAM_PATH}/unread`;
export const TAT_DATA = `${EXAM_PATH}/TAT`;
export const EXAM_DATA_READ = `${EXAM_PATH}/readdata`;
export const MISCELLANEOUS_SITE_DATA = `${EXAM_PATH}/miscellaneous-facility-data`;
export const EXAM_METRICS = `${EXAM_PATH}/exam-metrics`;

export const SITE_LIST = `${SITE_PATH}/facility-list`;
export const UNASSIGNED_SITES = `${SITE_PATH}/unassigned-facilities`;
export const SITEALIASMANAGEMENT_SITE = `${SITE_PATH}/FacilityAliasManagement`;
export const SITE_HOURLY_VOLUME_SHARE = `${SITE_PATH}/hourly-volume-share`;
export const SITE_PROFILE = `${SITE_PATH}/facilityprofile`;
export const EDIT_SITE_PROFILE = `${SITE_PATH}/edit-facility-profile`;

export const REPORT_CONFIGURATION = `${REPORT_PATH}/report-configuration`;
export const MATRIX_DAILY_REPORT = `${REPORT_PATH}/matrix-daily-report`;
export const PERFORMANCE_DASHBOARD = `${REPORT_PATH}/performance-dashboard`;
export const COVERAGE_GAP_TOOL = `${REPORT_PATH}/coverage-gap-tool`;
export const HOLIDAY_GAP_TOOL = `${REPORT_PATH}/holiday-gap-tool`;
export const PRIVILEGE_POWER_SYNC = `${REPORT_PATH}/privilege-power-sync`;
export const MATRIX_SERVICE_REQUEST = `${STRATEGIC_FORECAST_PATH}/matrix-service-request`;
export const STRATEGIC_DEMAND_PLANNER = `${STRATEGIC_FORECAST_PATH}/strategic-demand-planner`;
export const STRATEGIC_CAPACITY_PLANNER = `${STRATEGIC_FORECAST_PATH}/strategic-capacity-planner`;
export const STRATEGIC_CAPS_VS_DEMAND_PLANNER = `${STRATEGIC_FORECAST_PATH}/strategic-caps-vs-demand-planner`;

export const CAPACITY_TABLE = "/capacity-table";
export const CAPS_VS_DEMAND_TABLE = "/capacity-vs-demand-table";

export const SCHEDULE_SHARE_LINKS = "/schedule/share-links";
export const PUBLIC_SCHEDULE = "/public/schedule";
